export enum RoleCommission {
    KB_KAM = 'kb_kam',
    KB_CLOSER = 'kb_closer',
    PARTNER_PRO = 'partner_pro',
    PARTNER_DEVELOPER = 'partner_developer',
    PARTNER_REFERRAL = 'partner_referral',
    PARTNER_REFERRAL_PRO = 'partner_referral_pro',
}
